/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Art_Row_3Inputs */

const en_svc_n8n_art_row_3 = /** @type {(inputs: Svc_N8n_Art_Row_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New lead → HubSpot + Slack`)
};

const lv_svc_n8n_art_row_3 = /** @type {(inputs: Svc_N8n_Art_Row_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jauns pieteikums → HubSpot + Slack`)
};

/**
* | output |
* | --- |
* | "New lead → HubSpot + Slack" |
*
* @param {Svc_N8n_Art_Row_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_art_row_3 = /** @type {((inputs?: Svc_N8n_Art_Row_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Art_Row_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_art_row_3(inputs)
	return en_svc_n8n_art_row_3(inputs)
});